module.exports = __webpack_public_path__ + "bd3dd4cf8dd0e2c9088b2426b2c72498.pdf";